export default {
  en: { format: '%{time} ago' },
};
